



import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class CardSetting extends Vue {
  @Prop({required: true, type: String, default: ''}) type!: string
  @Prop({required: false, type: Boolean, default: true }) avatar!: boolean
  @Prop({required: false, type: Boolean, default: true }) hasIcon!: boolean

  private created() {
    this.urlImage()
  }
  private urlImg = {
    icon: '',
    img: ''
  }
  private urlImage() {
    if(this.type === 'pink') {
      this.urlImg.icon = require('@/assets/images/star-y.png')
      this.urlImg.img = require('@/assets/images/pink-bg.png')
    }
    if(this.type === 'orange') {
      this.urlImg.icon = require('@/assets/images/candy-blue.png')
      this.urlImg.img = require('@/assets/images/orange-bg.png')
    }
    if(this.type === 'green') {
      this.urlImg.icon = require('@/assets/images/candy-green.png')
      this.urlImg.img = require('@/assets/images/green-bg.png')
    }
  }

}
